import { render } from "./TemResource.vue?vue&type=template&id=fa478514&scoped=true"
import script from "./TemResource.vue?vue&type=script&lang=js"
export * from "./TemResource.vue?vue&type=script&lang=js"

import "./TemResource.vue?vue&type=style&index=0&id=fa478514&scoped=true&lang=css"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa478514"]])

export default __exports__